import { Slots } from 'vue';
import { isFunction } from '/@/utils/is';

/**
 * @description:  Get slot to prevent empty error
 */
export function getSlot(slots: Slots, slot = 'default', data?: any) {
  if (!slots || !Reflect.has(slots, slot)) {
    return undefined;
  }
  if (!isFunction(slots[slot])) {
    console.error(`${slot} is not a function!`);
    return undefined;
  }
  const slotFn = slots[slot];
  if (!slotFn) return undefined;
  return slotFn(data);
}

/**
 * extends slots
 * @param slots
 * @param excludeKeys
 */
export function extendSlots(slots: Slots, excludeKeys: string[] = []) {
  const slotKeys = Object.keys(slots);
  const ret: any = {};
  slotKeys.map((key) => {
    if (excludeKeys.includes(key)) {
      return undefined;
    }
    ret[key] = () => getSlot(slots, key);
  });
  return ret;
}
